import React, { useState, useRef, useContext, useEffect } from 'react';
import style from './Study.module.css';

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import { AppContext } from '../../AppContext';
import { Reorder } from 'framer-motion';
import FlashCards from './FlashCards/FlashCards';

import { motion } from 'framer-motion';
import icons from '../../icons';
import Add from './Add/Add';


let sectionsTouchInterval;

const Study = () => {
    const { sectionsOrder, updateSectionOrder: setSectionsOrder, editingSectionsOrder, setEditingSectionsOrder, flashCards } = useContext(AppContext);

    const [showTopBar, setShowTopBar] = useState(true);

    const [showAdd, setShowAdd] = useState(false);
    const [addProps, setAddProps] = useState({ type: "category" });
    const [page, setPage] = useState(0);
    const pageSwiper = useRef();

    const swipePage = index => {
        setPage(index);
        pageSwiper.current.swiper.slideTo(index);
    };

    useEffect(() => {
        pageSwiper.current.swiper.enabled = showTopBar;
    }, [showTopBar]);


    return <main className={ style.main } onClick={ () => setEditingSectionsOrder(false) }>
        <motion.div animate={{ height: (showTopBar && !showAdd) ? null : 0 }} style={{ overflow: "hidden" }}>
            <div style={{ display: "flex" }}>
                <h1 style={{ marginLeft: "2rem", color: "var(--orange)" }}>Studio</h1>
                <img src={ icons.add_icon } style={{ background: "var(--orange)", height: "1rem", width: "1rem", padding: ".5rem", borderRadius: "50%", marginTop: "auto", marginBottom: "auto", marginLeft: "auto", marginRight: "1rem" }} onClick={ () => setShowAdd(true) }></img>
            </div>
            {/* <Reorder.Group axis="x" values={ sectionsOrder.study ?? [] } onReorder={ newOrder => {
                localStorage.setItem("globalSectionsOrder", JSON.stringify({ ...sectionsOrder, study: newOrder }))
                setSectionsOrder({ study: newOrder });
            } } style={{ listStyleType: "none", padding: "0", margin: "0" }}>
                <section className={ style.pageChoices }>
                    { sectionsOrder.study?.map((section, idx) => <Reorder.Item key={ section } value={ section } dragListener={ editingSectionsOrder }>        
                        <div className={ [style.pageChoice, page === idx && style.selected, editingSectionsOrder && style.editingSectionsOrder].join(" ") } onClick={ () => swipePage(idx) } onTouchStart={ e => {
                            sectionsTouchInterval = setInterval(() => setEditingSectionsOrder(true), 500)
                            e.stopPropagation();
                        } }  onTouchMove={ () => clearInterval(sectionsTouchInterval) } onTouchEnd={ () => clearInterval(sectionsTouchInterval) } >
                            <h4>{ section }</h4>
                        </div>
                    </Reorder.Item>) }
                </section>
            </Reorder.Group> */}
            { Object.keys(flashCards ?? {}).length > 0 && <h4 style={{ marginLeft: "2rem", marginTop: ".5rem", marginBottom: "0" }}>Le tue flashcards</h4> }
        </motion.div>
        <motion.div animate={{ height: showAdd ? "0" : null, opacity: showAdd ? 0 : 1 }} transition={{ duration: 1 }} style={{ overflow: "hidden" }}>
            <Swiper ref={ pageSwiper } onSlideChange={ ({ activeIndex }) => setPage(activeIndex) } enabled={ showTopBar } allowTouchMove={ showTopBar }>
                { sectionsOrder.study?.map(section => {
                    switch (section) {
                        case "Flashcards":
                            return <SwiperSlide key={ section }><FlashCards showAdd={ () => setShowAdd(true) } setShowTopBar={ setShowTopBar } setAddProps={ addProps => setAddProps(addProps) } /></SwiperSlide>;
                        // case "???":
                        //     return <SwiperSlide key={ section }>
                        //         ???
                        //     </SwiperSlide>;
                    }
                }) }
            </Swiper>
        </motion.div>
        <motion.div animate={{ height: showAdd ? "100vh" : "0", opacity: showAdd ? 1 : 0 }} style={{ overflow: showAdd ? null : "hidden" }} transition={{ duration: 1 }}><Add hide={ () => setShowAdd(false) } setAddProps={ setAddProps } { ...addProps } /></motion.div>
    </main>;
}

export default Study;